<template>
    <div class="chargebee-upsell-config-pv3">
        <h4 class="typographies-paragraph-x-large-semibold chargebee-upsell-config-pv3__subtitle">
            {{ $l10n.__("Nombre d'utilisateurs") }}
        </h4>
        <!--        PACK CRM       -->
        <div class="chargebee-upsell-config-pv3__item chargebee-upsell-config-pv3__staff-container">
            <span class="typographies-paragraph-medium-regular">{{ $l10n.__('Utilisateur') }}</span>
            <div class="chargebee-upsell-config-pv3__item--right">
                <CompassNumberInput
                    :disabled="getEstimationLoading"
                    :modelValue="staffsNumber"
                    :min="previousStaffsNumber"
                    @change="(newValue) => updateStaffsQuantity('pack_crm_full', newValue)"
                />
                <div>
                    <span class="typographies-paragraph-medium-semibold">
                        {{ $filters.numberFormatCurrency(options.pack_crm.price / 100) }}
                    </span>
                    <span class="typographies-paragraph-small-regular">
                        /{{ recurrencyLabel(getRecurrence) }}
                    </span>
                </div>
            </div>
        </div>
        <h4 class="typographies-paragraph-x-large-semibold chargebee-upsell-config-pv3__subtitle">
            {{ $l10n.__('Options') }}
        </h4>
        <!--        PACK Invoicing       -->
        <div class="chargebee-upsell-config-pv3__item">
            <div class="chargebee-upsell-config-pv3__item--left">
                <CompassTooltip :content="getContentTooltip(isOptionEnabled('pack_invoicing'))">
                    <CompassSwitch
                        :disabled="true"
                        :modelValue="isOptionEnabled('pack_invoicing')"
                    />
                </CompassTooltip>
                <div class="chargebee-upsell-config-pv3__item--left-text">
                    <span class="typographies-paragraph-medium-regular">
                        {{ options.pack_invoicing.label }}
                    </span>
                    <p
                        class="typographies-paragraph-medium-regular chargebee-upsell-config-pv3__item--left-text-description"
                    >
                        {{
                            $l10n.__(
                                'Transformez vos devis en factures, activez la signature électronique et faites vous payer en ligne.',
                            )
                        }}
                    </p>
                </div>
            </div>
            <div class="chargebee-upsell-config-pv3__item--right">
                <div>
                    <span class="typographies-paragraph-medium-semibold">
                        {{ $filters.numberFormatCurrency(options.pack_invoicing.price / 100) }}
                    </span>
                    <span class="typographies-paragraph-small-regular">
                        /{{ recurrencyLabel(getRecurrence) }}
                    </span>
                </div>
            </div>
        </div>
        <!--        PACK MANAGEMENT       -->
        <div class="chargebee-upsell-config-pv3__item">
            <div class="chargebee-upsell-config-pv3__item--left">
                <CompassTooltip :content="getContentTooltip(isOptionEnabled('pack_management'))">
                    <CompassSwitch
                        :disabled="true"
                        :modelValue="isOptionEnabled('pack_management')"
                    />
                </CompassTooltip>
                <div class="chargebee-upsell-config-pv3__item--left-text">
                    <span class="typographies-paragraph-medium-regular">
                        {{ options.pack_management.label }}
                    </span>
                    <p
                        class="typographies-paragraph-medium-regular chargebee-upsell-config-pv3__item--left-text-description"
                    >
                        {{
                            $l10n.__(
                                'Saisissez vos achats, calculez vos marges, liez vos banques et exportez les écritures comptables.',
                            )
                        }}
                    </p>
                </div>
            </div>
            <div class="chargebee-upsell-config-pv3__item--right">
                <div>
                    <span class="typographies-paragraph-medium-semibold">
                        {{ $filters.numberFormatCurrency(options.pack_management.price / 100) }}
                    </span>
                    <span class="typographies-paragraph-small-regular">
                        /{{ recurrencyLabel(getRecurrence) }}
                    </span>
                </div>
            </div>
        </div>
        <!--        MODULE STOCK       -->
        <div v-if="isOptionEnabled('pack_stock')" class="chargebee-upsell-config-pv3__item">
            <div class="chargebee-upsell-config-pv3__item--left">
                <CompassTooltip :content="getContentTooltip(isOptionEnabled('pack_stock'))">
                    <CompassSwitch :disabled="true" :modelValue="true" />
                </CompassTooltip>
                <div class="chargebee-upsell-config-pv3__item--left-text">
                    <span class="typographies-paragraph-medium-regular">
                        {{ options.pack_stock.label }}
                    </span>
                    <p
                        class="typographies-paragraph-medium-regular chargebee-upsell-config-pv3__item--left-text-description"
                    >
                        {{
                            $l10n.__(
                                'Gérez vos stocks, vos entrepôts, vos commandes et soyez alerté en cas de rupture.',
                            )
                        }}
                    </p>
                </div>
            </div>
            <div class="chargebee-upsell-config-pv3__item--right">
                <div>
                    <span class="typographies-paragraph-medium-semibold">
                        {{ $filters.numberFormatCurrency(options.pack_stock.price / 100) }}
                    </span>
                    <span class="typographies-paragraph-small-regular">
                        /{{ recurrencyLabel(getRecurrence) }}
                    </span>
                </div>
            </div>
        </div>
        <!--        MODULE SUPPORT       -->
        <div v-if="isOptionEnabled('pack_support')" class="chargebee-upsell-config-pv3__item">
            <div class="chargebee-upsell-config-pv3__item--left">
                <CompassTooltip :content="getContentTooltip(isOptionEnabled('pack_support'))">
                    <CompassSwitch :disabled="true" :modelValue="true" />
                </CompassTooltip>
                <div class="chargebee-upsell-config-pv3__item--left-text">
                    <span class="typographies-paragraph-medium-regular">
                        {{ options.pack_support.label }}
                    </span>
                    <p
                        class="typographies-paragraph-medium-regular chargebee-upsell-config-pv3__item--left-text-description"
                    >
                        {{
                            $l10n.__(
                                'Affectez les tickets en un clic à vos collaborateurs, proposez un service personnalisé à vos clients.',
                            )
                        }}
                    </p>
                </div>
            </div>
            <div class="chargebee-upsell-config-pv3__item--right">
                <div>
                    <span class="typographies-paragraph-medium-semibold">
                        {{ $filters.numberFormatCurrency(options.pack_support.price / 100) }}
                    </span>
                    <span class="typographies-paragraph-small-regular">
                        /{{ recurrencyLabel(getRecurrence) }}
                    </span>
                </div>
            </div>
        </div>
        <!--        ROCKET       -->
        <div class="chargebee-upsell-config-pv3__item">
            <div class="chargebee-upsell-config-pv3__item--left">
                <CompassTooltip :content="getContentTooltip(isOptionEnabled('pack_cashflow'))">
                    <CompassSwitch
                        :disabled="true"
                        :modelValue="isOptionEnabled('pack_cashflow')"
                    />
                </CompassTooltip>
                <div class="chargebee-upsell-config-pv3__item--left-text">
                    <span class="typographies-paragraph-medium-regular">
                        {{ $l10n.__('Trésorerie') }}
                    </span>
                    <p
                        class="typographies-paragraph-medium-regular chargebee-upsell-config-pv3__item--left-text-description"
                    >
                        {{
                            $l10n.__(
                                'Visualisez votre trésorerie en temps réel et réalisez des prévisions.',
                            )
                        }}
                    </p>
                    <CompassSelect
                        :disabled="!isOptionEnabled('pack_cashflow')"
                        :modelValue="cashflowSelectedValue.id"
                        @update:modelValue="
                            (value) =>
                                updateLevelOption({
                                    optionNameKey: 'pack_cashflow',
                                    optionId: value,
                                })
                        "
                    >
                        <CompassDropdownOption
                            v-for="selectOption in options.pack_cashflow"
                            :key="selectOption.id"
                            :label="labelCashflow[selectOption.item_id]"
                            :value="selectOption.id"
                            :caption="getCaptionSelectPrice(selectOption)"
                        />
                    </CompassSelect>
                </div>
            </div>
            <div class="chargebee-upsell-config-pv3__item--right">
                <div>
                    <span class="typographies-paragraph-medium-semibold">
                        {{ $filters.numberFormatCurrency(cashflowSelectedValue.unit_price / 100) }}
                    </span>
                    <span class="typographies-paragraph-small-regular">
                        /{{ recurrencyLabel(getRecurrence) }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { debounce } from 'lodash';
const chargebeeUpsellStore = createNamespacedHelpers('chargebeeUpsellStore');
import ChargebeeUpsellMixin from 'mixins/chargebee/ChargebeeUpsellMixins';

export default {
    mixins: [ChargebeeUpsellMixin],
    data() {
        return {
            previousStaffsNumber: 0,
            labelCashflow: {
                pack_cashflow_starter_full: 'Standard',
                pack_cashflow_pro_full: 'Evolution',
                pack_cashflow_business_full: 'Elite',
            },
        };
    },
    computed: {
        ...chargebeeUpsellStore.mapGetters([
            'getChargebeeCatalogue',
            'getSubscriptionItems',
            'getPreviousSubscriptionItems',
            'getCustomerData',
            'getDiscounts',
            'getPreviousPlan',
            'getPlanSelected',
            'getEstimationLoading',
            'getRecurrence',
        ]),
        staffsNumber() {
            return this.countStaffs(this.getSubscriptionItems);
        },
        cashflowSelectedValue() {
            const cashflowSelectValue =
                this.getSubscriptionItems.find((option) => option.nameKey === 'pack_cashflow') ??
                this.options.pack_cashflow[0];
            cashflowSelectValue.id = cashflowSelectValue.id ?? cashflowSelectValue.item_price_id;
            cashflowSelectValue.amount = cashflowSelectValue.amount ?? cashflowSelectValue.price;
            return cashflowSelectValue;
        },
    },
    created() {
        this.previousStaffsNumber = this.countStaffs(this.getPreviousSubscriptionItems);
    },
    methods: {
        ...chargebeeUpsellStore.mapActions(['updateAddonQuantity', 'updateOptionLevel']),
        getCaptionSelectPrice(t) {
            return `${this.$filters.numberFormatCurrency(
                this.humanizeCentsPrice(t.price),
            )} /${this.recurrencyLabel(t.period_unit)}`;
        },
        countStaffs(subscriptionItems) {
            return subscriptionItems.reduce((acc, item) => {
                let id = item.item_price_id.split('_');
                id = id.slice(0, -2);
                id = id.join('_');
                if (id === 'pack_crm') {
                    return acc + item.quantity;
                }
                return acc;
            }, 0);
        },
        updateStaffsQuantity: debounce(function (itemId, newValue) {
            const humanizedRecurrence = this.getRecurrence === 'month' ? 'monthly' : 'yearly';
            itemId = itemId.concat('_', humanizedRecurrence);
            this.updateAddonQuantity({
                addonId: itemId,
                quantity: newValue,
            });
        }, 300),
        updateLevelOption: debounce(function ({ optionNameKey, optionId }) {
            try {
                const selectedValue = this.options[optionNameKey].find((option) => {
                    return option.id === optionId;
                });
                this.updateOptionLevel({ optionNameKey, option: selectedValue });
            } catch (e) {
                this.callError(e);
            }
        }, 200),
        getContentTooltip(isOptionEnabled) {
            if (isOptionEnabled) {
                return this.$l10n.__(
                    'Vous ne pouvez pas désactiver cette option. Veuillez contacter nos équipes pour en savoir plus.',
                );
            } else {
                return this.$l10n.__(
                    'Vous ne pouvez pas activer cette option. Veuillez contacter nos équipes pour en savoir plus.',
                );
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.chargebee-upsell-config-pv3 {
    display: flex;
    flex-direction: column;
    &__subtitle {
        margin: 0 0 var(--spacing-3);
    }
    &__staff-container {
        padding-bottom: var(--spacing-5);
        margin-bottom: var(--spacing-5);
        border-bottom: 1px solid var(--colors-common-border-default);
    }
    &__item {
        display: flex;
        justify-content: space-between;
        gap: var(--spacing-3);

        &:not(:last-of-type) {
            border-bottom: 1px solid var(--colors-common-border-lighter);
        }

        &:has(.chargebee-upsell-config-pv3__item--left-text-description) {
            padding: var(--spacing-3) 0;
            align-items: flex-start;
        }
        &--left {
            display: flex;
            align-items: flex-start;
            gap: var(--spacing-3);
            &-text {
                max-width: 393px;
                display: flex;
                flex-direction: column;

                &-description {
                    color: var(--colors-common-text-standard-caption);
                    margin: 0 0 var(--spacing-1);
                }
            }
        }
        &--right {
            display: flex;
            align-items: center;
            gap: var(--spacing-3);
        }
    }
}
</style>
